<template>
  <div class="nav" :class="[deviceType(), activityEnd ? 'activityEnd' : '']">
    <div class="pclogo"></div>
    <ul v-if="deviceType() == 'pc'">
      <li v-if="position == 'news'" class="navLi nav1 on">
        <router-link to="/news" class="official_guide"></router-link>
      </li>
      <li v-else class="navLi nav1">
        <router-link to="/news" class="official_guide"></router-link>
      </li>
      <li class="navLi nav2">
        <a
          :href="store.state.articlesData.carveUpEN"
          target="_blank"
          class="official_challenge"
        ></a>
      </li>
      <li class="navLi nav3">
        <a
          :href="store.state.articlesData.likeUrl"
          target="_blank"
          class="official_fb"
        ></a>
      </li>
      <li class="navLi nav4">
        <a
          :href="store.state.articlesData.payUrl"
          target="_blank"
          class="official_charge"
        ></a>
      </li>
    </ul>

    <!-- 分享 -->
    <div class="share">
      <a :href="store.state.articlesData['fbPageCN']" target="_blank">
        <img class="'official_fb'" src="../../../assets/images/yy/fb2.png" />
      </a>
      <a :href="store.state.articlesData.discordShare" target="_blank">
        <img
          :class="'official_gamer'"
          src="../../../assets/images/yy/dc2.png"
        />
      </a>
      <a
        @click="fillUpShare(ShareData)"
        v-if="deviceType() == 'pc'"
        target="_blank"
      >
        <img
          :class="'official_share'"
          src="../../../assets/images/yy/line2.png"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { shareFB } from "@/util/share";
import { deviceType } from "@/util/base";
import { useStore } from "vuex";
const store = useStore();

defineProps(["ShareData", "activityEnd", "position"]);

const fillUpShare = (data) => {
  const shareLink = window.location.href;
  let shareTitle = "";
  let shareImg =
    "https://gw-gat.res.etolies.com/resources/tkingdoms/share/share.jpeg";
  for (const item of data) {
    if (item.label === "shareTitle") {
      shareTitle = item.content;
    }
    // if (item.label === "shareImg") {
    //   shareImg = item.content;
    // }
  }
  console.log("分享参数===", shareLink, shareTitle, shareImg);
  shareFB(shareLink, shareTitle, shareImg);
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  z-index: 10;
  top: 0;
  background: url("../../../assets/images/yygw/pc-nav-bg.png") no-repeat center
    top;
  background-size: 100%;
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  color: #fff;
  display: flex;
  ul {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-content: center;
    background: url("../../../assets/images/yygw/pc-nav.png") no-repeat bottom
      left;
    background-size: 8.01rem 0.6rem;
    width: 8.01rem;
    height: 0.6rem;
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      cursor: pointer;
      font-size: 0.26rem;
      width: 1.71rem;
      height: 0.6rem;

      a {
        width: 100%;
        height: 0.6rem;
        color: #fbe2ab;
      }
      &:hover {
        background: url("../../../assets/images/yygw/pc-nav-on.png") no-repeat
          bottom left;
        background-size: 8.01rem 0.6rem;
      }
      &:nth-child(1) {
        background-position: 0 0;
        &.on {
          background: url("../../../assets/images/yygw/pc-nav-on.png") no-repeat
            bottom left;
          background-size: 8.01rem 0.6rem;
        }
      }
      &:nth-child(2) {
        background-position: -2.1rem 0;
      }
      &:nth-child(3) {
        background-position: -4.2rem 0;
      }
      &:nth-child(4) {
        background-position: -6.3rem 0;
      }
    }
  }
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.2rem;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.4rem;
        margin: 0 0.08rem;
      }
    }
  }

  .pclogo {
    position: fixed;
    left: 0.23rem;
    top: 0.09rem;
    width: 2.55rem;
    height: 1.18rem;
    background: url("../../../assets/images/yy/logo-pc.png") no-repeat center
      top;
    background-size: contain;
  }
}
.wap {
  height: 0.9rem;
  justify-content: space-between;
  .share {
    margin-right: 0.9rem;
    a {
      img {
        width: 0.55rem;
      }
    }
  }
}
</style>
